module.exports = __webpack_public_path__ + "static/media/eg.b0aa9a4e.svg";